import * as types from '../types.js'
const state = {
    parameters: {
        lists: [],
        search: null
    }
}
const getters = {
    hasList: (state) => (listId) => {
        if(state.parameters.lists.indexOf(listId) !== -1){
            return true
        }
        return false
    }
}
const actions = {
    [types.SEARCH_CHECK_LISTS]: ({commit}, lists) => {
        commit(types.SEARCH_COMMIT_PARAMETERS,{
            ...state.parameters,
            lists: [...(new Set([...state.parameters.lists, ...lists]))]
        })
    },
    [types.SEARCH_UNCHECK_ALL_LISTS]: ({state, commit}) => {
        commit(types.SEARCH_COMMIT_PARAMETERS, {...state.parameters, ...{lists: []}})
    },
    [types.SEARCH_SET_PARAMETERS]: ({commit}, parameters) => {
        commit(types.SEARCH_COMMIT_PARAMETERS, parameters)
    },
    [types.SEARCH_TOGGLE_LIST]: ({state, commit, getters}, {id, checked}) => {
        return new Promise((resolve, reject) => {
            if(getters.hasList(id) && checked === true){
                return resolve(true)
            }
            const params = {...state.parameters}
            params.lists = [...state.parameters.lists]

            if(checked){
                params.lists.push(id)
            }
            else{
                params.lists = params.lists.filter(crtId => crtId !== id)
            }
            commit(types.SEARCH_COMMIT_PARAMETERS, params)
            resolve(getters.hasList(id))
        })
    }
}
const mutations = {
    [types.SEARCH_COMMIT_PARAMETERS]: (state, parameters) => {
        state.parameters = parameters
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}